export default "__VITE_ASSET__BY6KBkKz__"